import { render, staticRenderFns } from "./MenusList.vue?vue&type=template&id=088f3452&scoped=true"
import script from "./MenusList.vue?vue&type=script&lang=js"
export * from "./MenusList.vue?vue&type=script&lang=js"
import style0 from "./MenusList.vue?vue&type=style&index=0&id=088f3452&prod&lang=scss&scoped=true"
import style1 from "./MenusList.vue?vue&type=style&index=1&id=088f3452&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088f3452",
  null
  
)

export default component.exports